export class DeheadingPeelingRequest{
    deheadingpeelingId:number
    scopeOfWork:string
    grade:string
    minGrade:number
    maxGrade:number
    ratePerKg:number
    isActive: boolean;
    createdUser: string;
    updatedAt: Date;
    createdAt:Date;
    updatedUser: string;
    versionFlag: number;
    foodTypeId?:number
    valueAddition1?: number
    valueAddition2?: number
    
    constructor(
        deheadingpeelingId:number,
        scopeOfWork:string,
        grade:string,
        minGrade:number,
        maxGrade:number,
        ratePerKg:number,
        isActive: boolean,
        createduser:string,
        updatedAt: Date,
        updateuser:string,
        versionflag:number,
        createdAt:Date,
        foodTypeId?: number,
        valueAddition1?: number,
        valueAddition2?: number
    ){
        this.deheadingpeelingId=deheadingpeelingId
        this.scopeOfWork=scopeOfWork
        this.grade=grade
        this.maxGrade=maxGrade
        this.minGrade=minGrade
        this.ratePerKg=ratePerKg
        this.isActive=isActive
        this.createdUser=createduser
        this.updatedAt=updatedAt
        this.updatedUser=updateuser
        this.versionFlag=versionflag
        this.createdAt=createdAt
        this.valueAddition1= valueAddition1
        this.valueAddition2 = valueAddition2
        this.foodTypeId = foodTypeId
    }
}
export class DeheadingPeelingRequestDto{
    data:DeheadingPeelingRequest[]
    user:string
    constructor(
        data:DeheadingPeelingRequest[],
        user:string 
    )
    {
        this.data = data
        this.user = user
    }
}